import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginForm from './componenents/Forms/LoginForm';
import AdminLayout from './componenents/Layouts/AdminLayout';
import CategoriesPage from './pages/CategoryPage';
import ArticlePage from './pages/ArticlePage';
import UserArticlePage from './pages/Users/UserArticlePage';
import MainLayout from './componenents/Layouts/MainLayout';
import UserArticleDetailPage from './pages/Users/UserArticleDetailPage';
import RegisterForm from './componenents/Forms/RegisterForm';
import CreateArticlePage from './pages/Admin/CreateArticlePage';
import SubCategoriesPage from './pages/SubCategoryPage';
import DashboardPage from './pages/DashboardPage';
import UserPage from './pages/UserPage';
import EditArticlePage from './pages/Admin/EditArticlePage';
import ForgotPasswordForm from './componenents/Forms/ForgotPasswordForm';
import ResetPasswordForm from './componenents/Forms/ResetPasswordForm';
import AdminViewArticlePage from './pages/Admin/AdminViewArticlePage';
import UserArticleSearchPage from './pages/Users/UserArticleSearchPage';


const AppRoutes = () => {
  return (
    <Router>
      <Routes>
      <Route path="/" element={<MainLayout><UserArticlePage /></MainLayout>} />
      <Route path="/search/:q" element={<MainLayout><UserArticleSearchPage /></MainLayout>} />
      <Route path="/articles/:id" element={<MainLayout><UserArticleDetailPage /> </MainLayout>} /> {/* Article detail route */}
        <Route path="/login" element={<LoginForm />} />
        <Route path="/register" element={<RegisterForm />} />
        <Route path="/forgot-password" element={<ForgotPasswordForm />} />
        <Route path="/reset-password" element={<ResetPasswordForm />} />
        <Route path="/admin" element={<AdminLayout />} >
        <Route path='home' element={<DashboardPage/>}/>

        <Route path='categories' element={<CategoriesPage/>}/>
        <Route path='users' element={<UserPage/>}/>
        <Route path='sub-categories' element={<SubCategoriesPage/>}/>
        <Route path='articles' element={<ArticlePage/>}/>
        <Route path='articles/new' element={<CreateArticlePage/>}/>
        <Route path='articles/edit/:id' element={<EditArticlePage />} />
        <Route path='articles/:id/view' element={<AdminViewArticlePage />} />
        
        </Route>
        {/* Add more routes as needed */}
      </Routes>
    </Router>
  );
};

export default AppRoutes;
